import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const imgUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export const DAYS = ["2026-10-30", "2026-10-31", "2026-11-01", "2026-11-02"];
export const DAY_SHORT = { "2026-10-30": "Fri 30", "2026-10-31": "Sat 31", "2026-11-01": "Sun 1", "2026-11-02": "Mon 2" };
export const ROLES = [
  { value: "setup", label: "Setup" },
  { value: "food", label: "Food" },
  { value: "parking_greeting", label: "Parking / Greeting" },
  { value: "cleanup", label: "Cleanup" },
  { value: "other", label: "Other" },
];

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d)))
      .join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const telHref = (phone) => `tel:+1${(phone || "").replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "")}`;

export async function downloadCsv(path, params, filename) {
  const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== "" && v != null));
  const res = await api.get(path, { params: clean, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
